import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import NodraRoutes from "routes";

const App = () => (
  <Router basename={process.env.PUBLIC_URL}>
    <NodraRoutes />
  </Router>
);

export default App;
